let _ctx = null;
let _iOSUnlocked = false;
let _silentEl = null;

/**
 * Mantém um <audio> silencioso em loop infinito.
 * O iOS só mantém a sessão em AVAudioSessionCategoryPlayback (ignora botão
 * silencioso) enquanto algum elemento de mídia HTML estiver ativo.
 * Sem o loop, a sessão cai de volta para Ambient após o primeiro som e os
 * sons seguintes voltam a ser cortados pelo botão lateral.
 */
function _unlockIOSPlayback() {
  if (_iOSUnlocked) return;
  _iOSUnlocked = true;
  try {
    const el = document.createElement('audio');
    el.setAttribute('playsinline', '');
    el.setAttribute('webkit-playsinline', '');
    el.src = '/sounds/silence.mp3';
    el.loop = true;          // manter sessão Playback viva indefinidamente
    el.volume = 0.001;       // praticamente inaudível
    el.play().catch(() => {});
    _silentEl = el;
  } catch {}
}

export function getSharedCtx() {
  if (!_ctx) {
    try { _ctx = new (window.AudioContext || window.webkitAudioContext)(); } catch {}
    _unlockIOSPlayback();
  }
  return _ctx;
}
